import { Receipt } from '../../../types/receipts';

export enum ActionTypes {
    GetLastReceipts = '[customer/lastReceipts] GET_LAST_RECEIPTS',
    LastReceiptsResponse = '[customer/lastReceipts] FETCH_LAST_RECEIPTS_RESPONSE',
}

export interface GetLastReceipts {
    type: ActionTypes.GetLastReceipts;
    payload: {
        accountId: string;
        id: string;
    };
}

export interface FetchLastReceiptsResponse {
    type: ActionTypes.LastReceiptsResponse;
    payload: {
        receipts: Receipt[];
    };
    meta: {
        cause: GetLastReceipts;
    };
}

export function getLastReceipts(accountId: string, id: string): GetLastReceipts {
    return {
        type: ActionTypes.GetLastReceipts,
        payload: {
            id,
            accountId,
        },
    };
}

export type Actions =
    | GetLastReceipts
    | FetchLastReceiptsResponse;
